import { Frame, Page } from "@shopify/polaris";

const Index = props => {


    return (
        <Frame>
            <Page fullWidth>
                <img style={{width: '100%'}} src="https://cdn.shopify.com/s/files/1/0763/1136/3891/files/sales-rep-data-original.png?v=1684854378" alt="Example" />
            </Page>
        </Frame>
    )
}


export default Index;